import { render, staticRenderFns } from "./SpecializationSlot.vue?vue&type=template&id=4783d700&scoped=true&"
import script from "./SpecializationSlot.vue?vue&type=script&lang=js&"
export * from "./SpecializationSlot.vue?vue&type=script&lang=js&"
import style0 from "./SpecializationSlot.vue?vue&type=style&index=0&id=4783d700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4783d700",
  null
  
)

export default component.exports